var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAirplanecomponent = function SvgAirplanecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.167V9.833L8.667 6.5V2.833c0-.553-.447-1-1-1-.554 0-1 .447-1 1V6.5L1.333 9.833v1.334L6.667 9.5v3.667l-1.334 1v1l2.334-.667 2.333.667v-1l-1.333-1V9.5L14 11.167Z",
    fill: "current"
  })));
};
export default SvgAirplanecomponent;